/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1DomainsDeleteDomainRequestBody = {
  /**
   * Identifies a domain by its Teral ID or by its name. Pass a 'dom_'-prefixed ID, or a fully
   *
   * @remarks
   * qualified domain name such as 'api.acme.com' without a scheme, port, or path. You can give an
   * internationalized name in Unicode or Punycode form. Both forms address the same domain.
   *
   * Domain names are unique per workspace, so the name alone addresses the domain. You do not
   * need to supply a project, app, or environment.
   */
  domain: string;
};

/** @internal */
export type V1DomainsDeleteDomainRequestBody$Outbound = {
  domain: string;
};

/** @internal */
export const V1DomainsDeleteDomainRequestBody$outboundSchema: z.ZodType<
  V1DomainsDeleteDomainRequestBody$Outbound,
  z.ZodTypeDef,
  V1DomainsDeleteDomainRequestBody
> = z.object({
  domain: z.string(),
});

export function v1DomainsDeleteDomainRequestBodyToJSON(
  v1DomainsDeleteDomainRequestBody: V1DomainsDeleteDomainRequestBody,
): string {
  return JSON.stringify(
    V1DomainsDeleteDomainRequestBody$outboundSchema.parse(
      v1DomainsDeleteDomainRequestBody,
    ),
  );
}
